// NATIVE 
import { useEffect, useState } from 'react';

// INSTALLED 
import { useDispatch, useSelector } from 'react-redux';
import { Grid, IconButton, Tooltip } from '@mui/material';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';

// CUSTOM 
import InputField from '../../formFields/InputField';
// import { getFormsDataS } from '../../../store/company';
import CheckboxField from '../../formFields/checkBoxField';
import { IDatosBasicos } from '../../../commons/interfaces';
import AutocompleteField from '../../formFields/autocompleteField';
import { setMunicipalyByDepartamentId } from '../../../store/municipaly';
import AutocompleteFieldCountry from '../../formFields/autocompleteFieldCountry';
import AutocompleteFieldDepartament from '../../formFields/AutocompleteFieldDepartament';




export const DatosBasicos = (props:any) => {

 

    const dispatch = useDispatch();

    // REDUX
    const { workplace_list_select }:any  = useSelector( (state:any) => state.workplace );

    const { country_list_select }:any  = useSelector( (state:any) => state.country );
    const { departaments_list_select }:any  = useSelector( (state:any) => state.departaments );
    const { municipaly_list_select }:any  = useSelector( (state:any) => state.municipalies );
    
    
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );
    const { economic_activity_list_select }:any = useSelector( (state:any) => state.economicactivity );
    const  { type_documents_list_select } = useSelector( (state:any) => state.tipodocumento );
    
    

    const { formField: {
        type_document,
        number_document,
        tradename,
        business_name,
        legal_representative,
        economic_activity,
        email,
        manager_in_charge,
        branch_offices,
        country,
        departament,
        municipaly,
        address_company,
        workplace,
        landline,
        cell_phone
      }
    } = props;




    
    // useEffect(() => {
    //   setActivityEconomic(economic_activity_list_select);
    // }, [economic_activity_list_select])
  
    

    



      const setMunicipaly = async(event:any) => {
         await dispatch( setMunicipalyByDepartamentId( event.value ) );  
      }

  

  

  return (
    <div>
        <Grid container spacing={2}>
            <Grid size={{ xs: 3 }}>
                <AutocompleteField 
                   options={type_documents_list_select}
                   name={type_document.name}
                   label={type_document.label}
                   element={type_document.name}
                />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={number_document.name}
                label={number_document.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
            <InputField 
                name={tradename.name}
                label={tradename.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={business_name.name}
                label={business_name.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={legal_representative.name}
                label={legal_representative.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={email.name}
                label={email.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={manager_in_charge.name}
                label={manager_in_charge.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
                 <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                 <CheckboxField  name={branch_offices.name} label={branch_offices.label}/>
                <Tooltip title="Seleccione si la compañia cuenta con alguna sucursal en caso de no contar con sucursales omita el proceso.">
                  <IconButton>
                    <HelpOutlineOutlinedIcon color='primary'/>
                  </IconButton>
                </Tooltip>
                 </div>
            </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 12 }}>
              <AutocompleteField  
                    options={economic_activity_list_select}
                    name={economic_activity.name}
                    label={economic_activity.label}
                    element={economic_activity.name}
                  />
            </Grid>
        </Grid>
        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 4 }}>
                  <AutocompleteFieldCountry
                      options={country_list_select}
                      name={country.name}
                      label={country.label}
                      element={country.name}
                  />
                  
            </Grid>
            <Grid size={{ xs: 4 }}>
                  <AutocompleteFieldDepartament 
                      options={departaments_list_select}
                      name={departament.name}
                      label={departament.label}
                      element={departament.name}
                  />
            </Grid>
            <Grid size={{ xs: 4 }}> 
                  <AutocompleteField 
                      options={municipaly_list_select}
                      name={municipaly.name}
                      label={municipaly.label}
                      element={municipaly.name}
                  />
            </Grid>
            
        </Grid> 
        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={address_company.name}
                label={address_company.label}
                variant="outlined"
                autoComplete="off" 
                onBlur={props.handleBlur}
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
                  <AutocompleteField 
                      options={workplace_list_select}
                      name={workplace.name}
                      label={workplace.label}
                  />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={landline.name}
                label={landline.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
            <Grid size={{ xs: 3 }}>
              <InputField 
                name={cell_phone.name}
                label={cell_phone.label}
                variant="outlined"
                autoComplete="off" 
                fullWidth
              />
            </Grid>
        </Grid>
       
        
    </div> 
  )
}


